define([
    "underscore",
    "backbone",
    "forms/withdrawal/common_form"
], function(_, Backbone, CommonForm) {
    return CommonForm.extend({
        url: "/rest_withdrawal/validate_one_two_pay_form"
    });
});
